export const METADATA_LOCAL_STORAGE_KEY = 'acadlyMetadata';
export const METADATA_LAST_FETCHED_TIME_LOCAL_STORAGE_KEY = 'acadlyMetadataLastFetchedTime';
